import AcceptInvitePage from './AcceptInvitePage';
import PasswordlessRecoveryPage from './PasswordlessRecoveryPage';
import { useAuthProviderName } from '../auth/useAuthProviderName';

/**
 * `/reset-password`.
 *
 * Under Keycloak this is — as it always was — the same token-and-new-password
 * form as `/accept-invite`; `AcceptInvitePage` reads `actionType` off the
 * invite and titles itself accordingly.
 *
 * Under Scalekit there is no password to reset, so the route renders guidance
 * instead of a form. It stays REGISTERED rather than redirecting: reset emails
 * sent before the cutover keep arriving here, and those users need a sentence,
 * not a bounce. See {@link PasswordlessRecoveryPage}.
 *
 * Deliberately NOT branching inside `AcceptInvitePage`: recovery and invite
 * acceptance are different jobs under Scalekit — one has a token to spend, the
 * other has nothing to do — and folding them together would put invite
 * machinery in front of someone who just wants to sign in.
 */
const ResetPasswordPage = () => {
  const provider = useAuthProviderName();
  return provider === 'scalekit' ? <PasswordlessRecoveryPage /> : <AcceptInvitePage />;
};

export default ResetPasswordPage;
